import { render, staticRenderFns } from "./SimSolicitudes.vue?vue&type=template&id=b3752a5e&"
import script from "./SimSolicitudes.vue?vue&type=script&lang=ts&"
export * from "./SimSolicitudes.vue?vue&type=script&lang=ts&"
import style0 from "./SimSolicitudes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b3752a5e', component.options)
    } else {
      api.reload('b3752a5e', component.options)
    }
    module.hot.accept("./SimSolicitudes.vue?vue&type=template&id=b3752a5e&", function () {
      api.rerender('b3752a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SIMSolicitudes/SimSolicitudes.vue"
export default component.exports